angular.module('picmonicng').directive('emailButton', function () {
  return {
    restrict: 'E',
    link: function (scope, element, attrs) {
      element.on('click', function () {
        send_ga('event', 'Referral', 'Email Button Clicked');
        $('.email-wrapper').slideToggle('fast');
        $('#email-input').select();
      });
    },
  };
});
